// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global google amaliaslimonad WOW */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),
        largeWidth: 1183,

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            console.log('%c This website was handcrafted by ❄ WINTER', 'color: #061c2c; display: block; font-size: 20px; font-family: "Muli", sans-serif;');
            console.log('%c Are you a developer? We\'d love to talk to you: inspector@winter.ax', 'color: #061c2c; display: block; font-size: 16px; font-family: "Muli", sans-serif;');
            console.log('%c www.winter.ax', 'color: #45bcec; display: block; font-size: 14px; font-family: "Muli", sans-serif;');

            wntrTheme.body.animate({
                'opacity': '1'
            }, 800);

            new WOW().init();

            // Check if we're heading to the anton page and if we're allowed to view it
            if(wntrTheme.body.find('.anton').length > 0 && localStorage.getItem('18_or_older') !== 'true') {
                // Remove the close buttpn from the fancy box

                // Open the fancybox
                $.fancybox.open({
                    src: '#anton-disclaimer',
                    type: 'inline',
                    opts: {
                        afterShow: function() {
                            wntrTheme.body.find('#anton-disclaimer .fancybox-close-small').remove();
                        }
                    }
                });

                // Set the correct link in the disclaimer window
                wntrTheme.body.find('.anton-disclaimer-link').attr('href', wntrTheme.body.find('.anton-disclaimer a').attr('href'));

                // Set local storage if we're 18+
                wntrTheme.body.find('a').on('click', function(e) {
                    e.preventDefault();
                });

                wntrTheme.body.find('.anton-disclaimer-link').on('click', function() {
                    localStorage.setItem('18_or_older', 'true');
                    window.location.href = $(this).attr('href');
                });

                wntrTheme.body.find('.anton-disclaimer-link-regret').on('click', function() {
                    window.location.href = $(this).attr('href');
                });
            }

            // Toggle mobile menu
            wntrTheme.body.find('.header__toggle').on('click', function() {
                $(this).toggleClass('is-active');
                wntrTheme.body.find('.header__mobile-menu').toggleClass('is-active');
                wntrTheme.body.toggleClass('menu-active');
                wntrTheme.body.toggleClass('is-fixed');
            });

            // Toggle desktop-lang-switcher
            wntrTheme.body.find('.desktop-language-switcher').on('mouseenter', function() {
                $(this).find('.toggle').removeClass('hidden');
            });

            // Toggle desktop-lang-switcher
            wntrTheme.body.find('.desktop-language-switcher').on('mouseleave', function() {
                $(this).find('.toggle').addClass('hidden');
            });

            // Toggle mobile menu
            wntrTheme.body.find('.header-toggle-btn').on('click', function() {
                const obj = $(this);
                wntrTheme.toggleMobileMenu(obj);
            });

            // Match height
            wntrTheme.body.find('.product-content').matchHeight();
            wntrTheme.body.find('.product-content h2').matchHeight();
            wntrTheme.body.find('.product-content p').matchHeight();
            wntrTheme.body.find('.product-image').matchHeight();
            wntrTheme.body.find('.term-product-content').matchHeight();
            wntrTheme.body.find('.facebook-post-inner').matchHeight();

            // Init gmaps
            if(wntrTheme.body.find('#gmap').length > 0 && typeof amaliaslimonad !== 'undefined') {
                wntrTheme.initGoogleMaps();
            }

            // Menu toggle
            wntrTheme.initMenuToggle();

            // Init carousel
            if(wntrTheme.body.find('.products-carousel')) {
                $('.products-carousel').slick({
                    dots: false,
                    arrows: true,
                    //infinite: true,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    //preconstrow: $('.prev'),
                    //nextArrow: $('.next'),
                    responsive: [
                        {
                            breakpoint: 1124,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 738,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            }
        },

        /**
        * Toggle mobile menu
        */
        toggleMobileMenu: function(obj) {
            obj.find('.header-toggle-svg-hide, .header-toggle-svg-show, .header-toggle-text-hide, .header-toggle-text-show').toggleClass('hide');
            obj.closest('.header-inner').find('.header-nav').slideToggle();
        },

        /**
         * Dropdown / submenu handler start
         */
        initMenuToggle: function() {

            const dropdownToggle = wntrTheme.body.find('.menu-item-has-children');

            if(!dropdownToggle.length) {
                return false;
            }

            const submenu = wntrTheme.body.find('.sub-menu');

            // desktop
            if($(window).width() > 1024) {

                // open menu on tabbing
                wntrTheme.body.find('.menu-item-has-children a').on('focus', function() {
                    $(this).parent('.menu-item-has-children').find('.sub-menu').addClass('is-active');
                });

                // close menu on 'body' click, but not inside of submenu
                wntrTheme.body.on('mousedown', function(e) {
                    if(!$(e.target).closest('.sub-menu').length && submenu.hasClass('is-active')) {
                        submenu.removeClass('is-active');
                    }
                });

                // close menu on press esc
                wntrTheme.body.on('keydown', function(e) {
                    if(e.key === "Escape" && submenu.hasClass('is-active')) {
                        submenu.removeClass('is-active');
                    }
                });

                // close menu after tabbing last link
                submenu.find('li:last-of-type > a').on('keydown', function(e) {
                    if(e.shiftKey && e.keyCode === 9) {
                        submenu.addClass('is-active');
                    } else if(e.keyCode === 9) {
                        submenu.removeClass('is-active');
                    }
                });

                // close on mouse out
                submenu.on('mouseout', function() {
                    submenu.removeClass('is-active');
                });

                // open current menu on mouse in
                dropdownToggle.on('mouseover', function() {
                    $(this).find('.sub-menu').addClass('is-active');
                });

                // open current menu on mouse in
                dropdownToggle.on('mouseout', function() {
                    $(this).find('.sub-menu').removeClass('is-active');
                });

            } else {
                dropdownToggle.on('click', function() {
                    $(this).find('.toggle-sub-menu').toggleClass('is-active');
                    $(this).find('.sub-menu').slideToggle(150);
                });
            }
        },

        /**
        * Init google maps
        */
        initGoogleMaps: function() {

            const map_type = amaliaslimonad.map_type;
            const locations = [];
            $.each(amaliaslimonad.markers, function(index, item) {
                locations.push([
                    item.title,
                    item.longitude,
                    item.latitude,
                    item.description
                ]);
            });

            let zoom;

            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && map_type !== 'contact') {
                zoom = 5;
            } else if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && map_type === 'contact') {
                zoom = 8;
            } else if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && map_type !== 'contact') {
                zoom = 6;
            } else if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && map_type === 'contact') {
                zoom = 10;
            }

            const map = new google.maps.Map(document.getElementById('gmap'), {
                zoom: zoom,
                disableDefaultUI: true,
                center: (map_type === 'contact' ? new google.maps.LatLng(locations[0][1], locations[0][2]) : new google.maps.LatLng(61.478619, 21.812606)),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                gestureHandling: 'cooperative',
                styles: [{ "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#747474" }, { "lightness": "23" }] }, { "featureType": "poi.attraction", "elementType": "geometry.fill", "stylers": [{ "color": "#f38eb0" }] }, { "featureType": "poi.government", "elementType": "geometry.fill", "stylers": [{ "color": "#ced7db" }] }, { "featureType": "poi.medical", "elementType": "geometry.fill", "stylers": [{ "color": "#ffa5a8" }] }, { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#c7e5c8" }] }, { "featureType": "poi.place_of_worship", "elementType": "geometry.fill", "stylers": [{ "color": "#d6cbc7" }] }, { "featureType": "poi.school", "elementType": "geometry.fill", "stylers": [{ "color": "#c4c9e8" }] }, { "featureType": "poi.sports_complex", "elementType": "geometry.fill", "stylers": [{ "color": "#b1eaf1" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "lightness": "100" }] }, { "featureType": "road", "elementType": "labels", "stylers": [{ "visibility": "off" }, { "lightness": "100" }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffd4a5" }] }, { "featureType": "road.arterial", "elementType": "geometry.fill", "stylers": [{ "color": "#ffe9d2" }] }, { "featureType": "road.local", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.local", "elementType": "geometry.fill", "stylers": [{ "weight": "3.00" }] }, { "featureType": "road.local", "elementType": "geometry.stroke", "stylers": [{ "weight": "0.30" }] }, { "featureType": "road.local", "elementType": "labels.text", "stylers": [{ "visibility": "on" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#747474" }, { "lightness": "36" }] }, { "featureType": "road.local", "elementType": "labels.text.stroke", "stylers": [{ "color": "#e9e5dc" }, { "lightness": "30" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "visibility": "on" }, { "lightness": "100" }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#d2e7f7" }] }]
            });

            const infowindow = new google.maps.InfoWindow();

            let marker, i;

            for(i = 0; i < locations.length; i++) {
                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(locations[i][1], locations[i][2]),
                    map: map
                });

                (map_type === 'contact' ? marker.setIcon('https://maps.google.com/mapfiles/ms/icons/red-dot.png') : marker.setIcon('https://maps.google.com/mapfiles/ms/icons/orange-dot.png'));

                google.maps.event.addListener(marker, 'click', (function(marker, i) {
                    return function() {
                        infowindow.setContent(
                            '<div class="gmaps-marker-info">' +
                            '<h2>' + locations[i][0] + '</h2>' +
                            '<p>' + locations[i][3] + '<p>' +
                            '</div>');
                        infowindow.open(map, marker);
                    };
                })(marker, i));
            }
        }
    };

    $(document).ready(wntrTheme.init);
})(jQuery);
